// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import 'myWorld/base/control';
import '../uiComponents/index';

/**
 * Control to render the title and short description of the features in the current feature set <br/>
 * Each item includes behaviour to allow the user to select and zoom to the feature
 * @name TraceResultControl
 * @constructor
 * @extends {Control}
 */
myw.TraceResultControl = myw.Control.extend({
    messageGroup: 'TracePlugin',

    initialize(owner, options) {
        myw.Control.prototype.initialize.call(this, owner, options);
    },

    render() {
        this.rootBranch = this.app.currentFeatureSet.start;
        this.app.currentFeatureSet.start.buildSpine();

        const treeView = new myw.TreeView({
            messageGroup: 'TracePlugin',
            app: this.app,
            root: this.rootBranch,
            zoomEnabled: true,
            leafRenderer(node, type) {
                if (type === 'node') {
                    return `Branch: ${node.feature.getTitle()}`;
                }
                return node.feature.getTitle();
            },
            branchRenderer(children) {
                return `Branch: ${children.length} objects`;
            }
        });
        treeView.render();
        this.tableContainer = $('<div id="#results-content-table" class="verticalScroll">')
            .append(treeView.$el)
            .scrollTop(0);

        this.$el.html(this.tableContainer);

        this._setTableHeight();
    },

    _setTableHeight() {
        const detailsTabSpace = this.$el.parent(),
            resultReportHeight =
                this.limitReport && this.limitReport.is(':visible')
                    ? this.limitReport.outerHeight()
                    : 0,
            navBarHeight = this.$el.siblings('.navigation-bar').outerHeight(),
            panelContentHeight = detailsTabSpace.height() - navBarHeight,
            topBarHeight = this.$el.siblings('.top').outerHeight() || 0; //Used in the phone layout

        this.tableContainer.height(panelContentHeight - resultReportHeight - topBarHeight);
    },

    invalidateSize() {
        if (this.tableContainer) this._setTableHeight();
    },

    hide() {
        this.$el.hide();
        this.undelegateEvents();
    }
});

export default myw.TraceResultControl;
